import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import type { Field } from 'factorial-form'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type AccessGroupForm from 'modules/surveys/components/AccessGroupForm'

interface Props {
  loading: boolean
  form: AccessGroupForm
  name: Field
}

function Footer({ loading, form, name }: Props) {
  const disabled = loading || !form.valid() || !name.value

  return (
    <Button disabled={disabled} submit>
      {i18n.t('surveys.new.submit')}
    </Button>
  )
}

export default observer(Footer)
